import { FunctionComponent } from 'react';

// Components
import Rater from 'react-rater';
import Image from '@Components/Utils/Image';

// Utilities
import moment from 'moment';
import classnames from 'classnames';
import { getAttachmentAvatar } from '@Libs/utils';

// Contexts
import { useViewDetected, ViewMedia } from '@Components/Utils/ViewDetected';

// Styles
import styles from './CommentItem.module.scss';
interface CommentItemProps {
    comment?: any;
    className?: string;
    bodyClassName?: string;
    avatarClassName?: string;
}

const CommentItem: FunctionComponent<CommentItemProps> = ({ comment, ...props }) => {
    const { deviceType } = useViewDetected();

    const { creatorUserId, creatorUserType } = comment;

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        props.className,
    ]);

    const bodyClassName = classnames([styles.body, props.bodyClassName]);
    const avatarClassName = classnames([styles.avatar, props.avatarClassName]);

    return (
        <div className={className}>
            <Image className={avatarClassName} src={getAttachmentAvatar(creatorUserId, creatorUserType)} />
            <div className={bodyClassName}>
                <div className={styles.head_comment}>
                    <div className={styles.name_wrapper}>
                        {comment?.creator?.fullName}
                        <div className={styles.star_wrapper}>
                            <Rater total={5} rating={comment?.point} interactive={false} />
                        </div>
                    </div>
                    <ViewMedia is="desktop">
                        <span className={styles.time}>{moment(comment?.createTime).format('h:mm, DD/MM/YYYY')}</span>
                    </ViewMedia>
                </div>
                <div className={styles.content}>{comment?.comment}</div>
                <ViewMedia is={['mobile', 'tablet']}>
                    <span className={styles.time}>{moment(comment?.createTime).format('h:mm, DD/MM/YYYY')}</span>
                </ViewMedia>
            </div>
        </div>
    );
};

CommentItem.defaultProps = {
    comment: {},
    className: '',
    bodyClassName: '',
    avatarClassName: '',
};

export default CommentItem;
